import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'pa',
  months: ['ਜਨਵਰੀ', 'ਫਰਵਰੀ', 'ਮਾਰਚ', 'ਅਪ੍ਰੈਲ', 'ਮਈ', 'ਜੂਨ', 'ਜੁਲਾਈ', 'ਅਗਸਤ', 'ਸਤੰਬਰ', 'ਅਕਤੂਬਰ', 'ਨਵੰਬਰ', 'ਦਸੰਬਰ'],
  monthsShort: ['ਜਨ', 'ਫਰ', 'ਮਾਰਚ', 'ਅਪ੍ਰੈਲ', 'ਮਈ', 'ਜੂਨ', 'ਜੁਲ', 'ਅਗ', 'ਸਤੰ', 'ਅਕ', 'ਨਵੰ', 'ਦਸੰ'],
  weekdays: ['ਐਤਵਾਰ', 'ਸੋਮਵਾਰ', 'ਮੰਗਲਵਾਰ', 'ਬੁੱਧਵਾਰ', 'ਵੀਰਵਾਰ', 'ਸ਼ੁੱਕਰਵਾਰ', 'ਸ਼ਨੀਵਾਰ'],
  weekdaysMin: ['ਐਤ', 'ਸੋਮ', 'ਮੰਗਲ', 'ਬੁੱਧ', 'ਵੀਰ', 'ਸ਼ੁੱਕਰ', 'ਸ਼ਨੀ'],
  weekdaysShort: ['ਐਤ', 'ਸੋਮ', 'ਮੰਗਲ', 'ਬੁੱਧ', 'ਵੀਰ', 'ਸ਼ੁੱਕਰ', 'ਸ਼ਨੀ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'ਸਵੇਰੇ', pm: 'ਸ਼ਾਮ', AM: 'ਸਵੇਰੇ', PM: 'ਸ਼ਾਮ' },
  past: {
    y: { one: '%s ਸਾਲ ਪਹਿਲਾਂ', other: '%s ਸਾਲ ਪਹਿਲਾਂ' },
    M: { one: '%s ਮਹੀਨਾ ਪਹਿਲਾਂ', other: '%s ਮਹੀਨੇ ਪਹਿਲਾਂ' },
    w: { one: '%s ਹਫ਼ਤਾ ਪਹਿਲਾਂ', other: '%s ਹਫ਼ਤੇ ਪਹਿਲਾਂ' },
    d: { one: '%s ਦਿਨ ਪਹਿਲਾਂ', other: '%s ਦਿਨ ਪਹਿਲਾਂ' },
    h: { one: '%s ਘੰਟਾ ਪਹਿਲਾਂ', other: '%s ਘੰਟੇ ਪਹਿਲਾਂ' },
    m: { one: '%s ਮਿੰਟ ਪਹਿਲਾਂ', other: '%s ਮਿੰਟ ਪਹਿਲਾਂ' },
    s: { one: '%s ਸਕਿੰਟ ਪਹਿਲਾਂ', other: '%s ਸਕਿੰਟ ਪਹਿਲਾਂ' },
  },
  future: {
    y: { one: '%s ਸਾਲ ਵਿੱਚ', other: '%s ਸਾਲਾਂ ਵਿੱਚ' },
    M: { one: '%s ਮਹੀਨੇ ਵਿੱਚ', other: '%s ਮਹੀਨਿਆਂ ਵਿੱਚ' },
    w: { one: '%s ਹਫ਼ਤੇ ਵਿੱਚ', other: '%s ਹਫ਼ਤਿਆਂ ਵਿੱਚ' },
    d: { one: '%s ਦਿਨ ਵਿੱਚ', other: '%s ਦਿਨਾਂ ਵਿੱਚ' },
    h: { one: '%s ਘੰਟੇ ਵਿੱਚ', other: '%s ਘੰਟਿਆਂ ਵਿੱਚ' },
    m: { one: '%s ਮਿੰਟ ਵਿੱਚ', other: '%s ਮਿੰਟਾਂ ਵਿੱਚ' },
    s: { one: '%s ਸਕਿੰਟ ਵਿੱਚ', other: '%s ਸਕਿੰਟਾਂ ਵਿੱਚ' },
  },
  pastLong: {
    y: { one: '%s ਸਾਲ ਪਹਿਲਾਂ', other: '%s ਸਾਲ ਪਹਿਲਾਂ' },
    M: { one: '%s ਮਹੀਨਾ ਪਹਿਲਾਂ', other: '%s ਮਹੀਨੇ ਪਹਿਲਾਂ' },
    w: { one: '%s ਹਫ਼ਤਾ ਪਹਿਲਾਂ', other: '%s ਹਫ਼ਤੇ ਪਹਿਲਾਂ' },
    d: { one: '%s ਦਿਨ ਪਹਿਲਾਂ', other: '%s ਦਿਨ ਪਹਿਲਾਂ' },
    h: { one: '%s ਘੰਟਾ ਪਹਿਲਾਂ', other: '%s ਘੰਟੇ ਪਹਿਲਾਂ' },
    m: { one: '%s ਮਿੰਟ ਪਹਿਲਾਂ', other: '%s ਮਿੰਟ ਪਹਿਲਾਂ' },
    s: { one: '%s ਸਕਿੰਟ ਪਹਿਲਾਂ', other: '%s ਸਕਿੰਟ ਪਹਿਲਾਂ' },
  },
  futureLong: {
    y: { one: '%s ਸਾਲ ਵਿੱਚ', other: '%s ਸਾਲਾਂ ਵਿੱਚ' },
    M: { one: '%s ਮਹੀਨੇ ਵਿੱਚ', other: '%s ਮਹੀਨਿਆਂ ਵਿੱਚ' },
    w: { one: '%s ਹਫ਼ਤੇ ਵਿੱਚ', other: '%s ਹਫ਼ਤਿਆਂ ਵਿੱਚ' },
    d: { one: '%s ਦਿਨ ਵਿੱਚ', other: '%s ਦਿਨਾਂ ਵਿੱਚ' },
    h: { one: '%s ਘੰਟੇ ਵਿੱਚ', other: '%s ਘੰਟਿਆਂ ਵਿੱਚ' },
    m: { one: '%s ਮਿੰਟ ਵਿੱਚ', other: '%s ਮਿੰਟਾਂ ਵਿੱਚ' },
    s: { one: '%s ਸਕਿੰਟ ਵਿੱਚ', other: '%s ਸਕਿੰਟਾਂ ਵਿੱਚ' },
  },
  abbr: {
    y: { one: '%sਸਾਲ', other: '%sਸਾਲ' },
    M: { one: '%sਮਿੰ', other: '%sਮਿੰ' },
    w: { one: '%sਹਫਤਾ', other: '%sਹਫਤਾ' },
    d: { one: '%sਦਿ', other: '%sਦਿ' },
    h: { one: '%sਘੰ', other: '%sਘੰ' },
    m: { one: '%sਮਿੰਟ', other: '%sਮਿੰਟ' },
    s: { one: '%sਸ', other: '%sਸ' },
  },
  full: {
    y: { one: '%s ਸਾਲ', other: '%s ਸਾਲ' },
    M: { one: '%s ਮਹੀਨਾ', other: '%s ਮਹੀਨੇ' },
    w: { one: '%s ਹਫ਼ਤਾ', other: '%s ਹਫ਼ਤੇ' },
    d: { one: '%s ਦਿਨ', other: '%s ਦਿਨ' },
    h: { one: '%s ਘੰਟਾ', other: '%s ਘੰਟੇ' },
    m: { one: '%s ਮਿੰਟ', other: '%s ਮਿੰਟ' },
    s: { one: '%s ਸਕਿੰਟ', other: '%s ਸਕਿੰਟ' },
  },
  justNow: 'ਹੁਣੇ ਹੀ',
  yesterday: 'ਬੀਤਿਆ ਕੱਲ੍ਹ',
  today: 'ਅੱਜ',
  tomorrow: 'ਭਲਕੇ',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'MMMM D', end: 'D MMMM YYYY' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'pa';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'ਸਵੇਰੇ' : 'ਸਵੇਰੇ';
    } else {
      return isLowerCase ? 'ਸ਼ਾਮ' : 'ਸ਼ਾਮ';
    }
  },
};
